<div class="container my-5" style="    font-size: 25px;">
    <h1>Conditions d’utilisation</h1>
    <h4>Bienvenue sur COVID-19-TN</h4>



    <h3>Quel type d'informations nous collectons ?</h3>
    <ul>
        <li>
            Nous ne suivons aucune information personnelle sur l'appareil ou aucune information confidentielle, nous collectons uniquement les données fournies par l'utilisateur dont il a déjà accepté nos conditions d'utilisation.
        </li>
        <li>
            Nous collectons uniquement des informations qui peuvent nous aider à vous aider, et les fournir aux autorités qui peuvent vous aider.
        </li>
    </ul>

    <h3>Comment nous utilisons les informations que nous recueillons sur vous ?</h3>
    <ul>
        <li>
            Une fois que nous avons obtenu de nouvelles données d'un utilisateur, nous mettons à jour la carte et la rendons visible aux autre utilisateur la zone infectée.
        </li>
        <li>
            Pour utiliser ce produit, nous devons traiter des informations vous concernant. Les types d’informations que nous recueillons dépendent de la manière dont vous utilisez ce produit.
        </li>
        <li>
            Nous ne partagerons pas votre position exacte sur la carte et nous ne partageons aucune information confidentielle à votre sujet, nous allons simplement rendre votre position un peu plus gloabale afin que les autres utilisateurs puissent voir la zone infectée.
        </li>
        <li>
            Aucune de vos informations personnelles ne sera partagée avec d'autres utilisateurs, les informations que nous collectons ne seront montrées qu'à Les autorités concernées.
   
        </li>
        
    </ul>
 


</div>